import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import EditSiteCopyModal from '../../Modals/SiteCopy/EditSiteCopyModal';
import style from './styles/style.module.css';

class InfiniteSiteCopyTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            copyInEdit: null,
            copyInEditIndex: -1,
        };
    }
    updateSiteCopy = ( index, desireid, data ) => {
        this.props.updateSiteCopy( desireid, data )
        .then( ( copy ) => {
            return this.props.onSiteCopyUpdated && this.props.onSiteCopyUpdated( index, copy );
        } );
    }
    openEditModal = ( index, copy ) => {
        this.setState( { copyInEdit: copy, copyInEditIndex: index } );
    }
    onEditSubmit = ( copy ) => {
        var index = this.state.copyInEditIndex;
        this.props.onSiteCopyUpdated( index, copy );
        this.setState( { copyInEdit: null, copyInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { copyInEdit: null, copyInEditIndex: -1 } );
    }



    render() {
        const { copyList } = this.props;
        const { copyInEdit } = this.state;

        return (
            <div>
                <InfiniteTable
                className={ style.copyListTable }
                elementHeight={ 90 }>
                    { this.arrayTableRows( copyList ) }
                </InfiniteTable>
                { copyInEdit !== null &&
                    <EditSiteCopyModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    copy={ copyInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( copyList ) => {
        var rows = copyList.map( ( copy, index ) => {
            var page = '', section = '';
            var pageName = copy.name ? copy.name.split( ':' ) : ['',''];
            if( pageName[ 0 ] ){
                page = pageName[ 0 ].split( '_' )
                .map( word => ( word.charAt( 0 ).toUpperCase() + word.slice( 1 ) ) )
                .join( ' ' );
            }
            if( pageName[ 1 ] ){
                section = pageName[ 1 ].split( '_' )
                .map( word => ( word.charAt( 0 ).toUpperCase() + word.slice( 1 ) ) )
                .join( ' ' );
            }
            return (
                <InfiniteTable.Row key={ copy.id } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        { page }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { section }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        { copy.name }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <div className={ style.copyText } dangerouslySetInnerHTML={ { __html: copy.copy_text } }></div>
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, copy );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    PAGE
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    SECTION
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    KEY
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    COPY
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
InfiniteSiteCopyTable.defaultProps = {
    onSiteCopyUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateSiteCopy: ( name, data ) => {
            return dAPI.patch( `/admin/dynamicCopy/${ name }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( InfiniteSiteCopyTable );
